"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGlobalVirtualCategory = void 0;
const routes_1 = require("../../routes");
const updateGlobalVirtualCategory = (client) => async (params, data) => {
    const url = routes_1.ENDPOINTS.UPDATE_GLOBAL_VIRTUAL_CATEGORY.applyParams(params);
    const response = await client.put(url, data);
    return response.data;
};
exports.updateGlobalVirtualCategory = updateGlobalVirtualCategory;
